import { createQueryKeys } from '@lukemorales/query-key-factory'

import {
  listAllIndicators,
  listStoplightsNotes,
  supportedLanguages,
} from '~/services/survey-builder-services'
import { getSurveysDefinition } from '~/services/survey-services'
import { type PlatformLanguage } from '~/utils/types/i18n'

export const surveysQueries = createQueryKeys('surveys', {
  listDefinitions: () => ({
    queryKey: ['listDefinitions'],
    queryFn: async () => await getSurveysDefinition(),
  }),
  notes: (stoplightId: number) => ({
    queryKey: ['notes', stoplightId],
    queryFn: async () => {
      return await listStoplightsNotes(stoplightId)
    },
  }),
  supportedLanguages: (language: PlatformLanguage) => ({
    queryKey: ['supportedLanguages', language],
    queryFn: supportedLanguages,
  }),
  listAllIndicators: (
    filter: string,
    surveyLanguage: string,
    platformLanguage: PlatformLanguage,
  ) => ({
    queryKey: ['listAllIndicators', filter, surveyLanguage, platformLanguage],
    queryFn: async () => await listAllIndicators(filter, surveyLanguage),
  }),
})
